import { render, staticRenderFns } from "./group.vue?vue&type=template&id=154fca80&scoped=true&"
import script from "./group.vue?vue&type=script&lang=ts&"
export * from "./group.vue?vue&type=script&lang=ts&"
import style0 from "./group.vue?vue&type=style&index=0&id=154fca80&prod&lang=scss&scoped=true&"
import style1 from "./group.vue?vue&type=style&index=1&id=154fca80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154fca80",
  null
  
)

export default component.exports